import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";

import useCursorStore from "../../store/cursorStore";
import useFlowStore from "../../store/flowStore";
import { images } from "../../../assets/assets";

export default function EndUI() {
  const endUIRef = useRef();
  const uiRef = useRef();
  const logoRef = useRef();
  const containerRef = useRef();
  const photoRef = useRef();
  const contentRef = useRef();
  const singleDoorRef = useRef();
  const secondWrapperRef = useRef();
  const secondWrapperContentRef = useRef();

  const [doorClicked, setDoorClicked] = useState(false);

  const { playCurrentAudio, playAudioFile, setSceneVisible } =
    useFlowStore.getState();
  const { setCursorScale, setCursorInteractive } = useCursorStore.getState();

  useEffect(() => {
    setCursorInteractive(true);

    // Animation d'entrée du bloc UI
    gsap.fromTo(
      endUIRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 1.5, ease: "power2.inOut" }
    );

    setTimeout(() => {
      setSceneVisible("hub", false);
      setSceneVisible("secondaryScene", false);
    }, 3000);

    // Layout flex (photo à gauche)
    const photo = photoRef.current;
    const content = contentRef.current;

    gsap.set(photo, { opacity: 0 });
    gsap.set(secondWrapperContentRef.current, { pointerEvents: "none" });

    // On attend le layout pour un calcul juste
    setTimeout(() => {
      // Calcule la position actuelle de la photo
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const rect = photo.getBoundingClientRect();

      // Centre actuel de la photo dans le layout flex
      const photoCenterX = rect.left + rect.width / 2;
      const photoCenterY = rect.top + rect.height / 2;

      // Centre de l'écran
      const targetX = vw / 2;
      const targetY = vh / 2;

      // Décalage pour centrer la photo
      const dx = targetX - photoCenterX;
      const dy = targetY - photoCenterY;

      // Applique la translation + scale initiale (centré, agrandi)
      gsap.set(photo, {
        x: dx,
        y: dy,
        scale: 1.5,
        zIndex: 10,
      });

      gsap.set(photo, { opacity: 1 });

      gsap.to(secondWrapperRef.current, {
        opacity: 1,
        duration: 0.6,
        ease: "power2.inOut",
      });

      playCurrentAudio();

      setTimeout(() => {
        // Anime la photo à sa place naturelle + scale normale
        gsap.to(photo, {
          x: 0,
          y: 0,
          scale: 1,
          duration: 2,
          ease: "power2.inOut",
          delay: 2.5, // Délai pour scale la photo
          onComplete: () => {
            gsap.to(content, {
              opacity: 1,
              duration: 1.1,
              ease: "power2.out",
            });
            gsap.to(singleDoorRef.current, {
              transform: "translate(-50%, 85%)",
              // opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              delay: 2.5,
            });
            gsap.to(logoRef.current, {
              opacity: 1,
              duration: 1.1,
              ease: "power2.out",
            });
          },
        });
        setTimeout(() => {
          gsap.to(singleDoorRef.current, {
            transform: "translate(-50%, 40%)",
            duration: 0.4,
            ease: "power2.out",
          });

          gsap.to(uiRef.current, {
            yPercent: -150,
            duration: 1.2,
            ease: "power2.inOut",
            onComplete: () => {
              gsap.to(secondWrapperContentRef.current, {
                opacity: 1,
                pointerEvents: "auto",
                duration: 0.6,
                ease: "power2.inOut",
              });
            },
          });
        }, 15000);
      }, 25000);
    }, 1500);
  }, []);

  const handleHover = () => {
    if (doorClicked) return;
    // gsap.to(singleDoorRef.current, {
    //   yPercent: -10, // ou la valeur que tu veux (en pixels)
    //   duration: 0.4,
    //   ease: "power2.out",
    // });
  };

  const handleLeave = () => {
    if (doorClicked) return;
    // gsap.to(singleDoorRef.current, {
    //   yPercent: 0,
    //   duration: 0.4,
    //   ease: "power2.out",
    // });
  };

  // const handleClick = () => {
  //   if (doorClicked) return;
  //   setDoorClicked(true);

  //   gsap.to(singleDoorRef.current, {
  //     transform: "translate(-50%, 40%)",
  //     duration: 0.4,
  //     ease: "power2.out",
  //   });

  //   gsap.to(uiRef.current, {
  //     yPercent: -150,
  //     duration: 1.2,
  //     ease: "power2.inOut",
  //     onComplete: () => {
  //       gsap.to(secondWrapperContentRef.current, {
  //         opacity: 1,
  //         pointerEvents: "auto",
  //         duration: 0.6,
  //         ease: "power2.inOut",
  //       });
  //     },
  //   });
  // };

  return (
    <div ref={endUIRef} className="endUI__totalWrapper">
      <div className="endUI__header">
        <img
          src={images.logo}
          alt="Logo"
          className="endUI__logo"
          ref={logoRef}
        />
      </div>
      <div
        className="endUI__secondWrapper__content"
        ref={secondWrapperContentRef}
      >
        <div className="endUI__secondWrapper__content__wrapper">
          <h1>Merci pour le Rêve de Lilian</h1>
          <p>
            Des centaines de portes attendent d’être ouvertes
          </p>
        </div>
        <div className="endUI__secondWrapper__content__buttons">
          <a
            href="https://www.reves.fr/aider/faire-un-don/"
            target="_blank"
            className="button button--alt"
            onPointerEnter={() => setCursorScale(3)}
            onPointerLeave={() => setCursorScale(1)}
            rel="noopener noreferrer"
          >
            Contribuer à un rêve
            <svg
              width="195"
              height="49"
              viewBox="0 0 195 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M160.881 1.92937C172.945 5.45399 179.992 11.2481 185.5 16C192.213 21.7918 199.941 33.9365 189.425 39.2061C178.791 44.535 151.537 43.2177 131.433 44.8708C116.163 46.1266 101.889 47.5306 86.0547 47.7065C66.2856 47.9261 42.4875 50.1509 28.4393 46.015C14.3975 41.881 13.9731 38.2518 9.99968 32.5C5.72301 26.3092 -5.46232 16.813 4.39718 11.2124C14.2827 5.59695 43.2307 7.18954 63.6996 5.39823C79.5006 4.01543 94.1233 1.33036 110.472 1.92937C127.164 2.54095 148.892 -1.57312 160.881 1.92937Z"
                fill="white"
              />
            </svg>
          </a>
          <a
            href="https://reves.fr"
            target="_blank"
            className="button"
            onPointerEnter={() => setCursorScale(3)}
            onPointerLeave={() => setCursorScale(1)}
            rel="noopener noreferrer"
          >
            Accèder au site
            <svg
              width="191"
              height="49"
              viewBox="0 0 191 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M135.498 1.84375C144.26 1.34403 152.282 1.20257 158.05 2.73535L158.601 2.88965C164.278 4.54841 166.965 8.02634 168.938 11.7764C169.436 12.7232 169.886 13.6841 170.331 14.6455C170.773 15.5999 171.213 16.5638 171.676 17.4795C172.541 19.1921 173.532 20.8337 174.911 22.1182L175.192 22.3701C176.924 23.8644 179.201 25.395 181.404 26.8916C183.639 28.4093 185.804 29.8956 187.43 31.3506C188.24 32.0759 188.884 32.7645 189.327 33.4141C189.772 34.0657 189.976 34.6218 189.998 35.0957C190.035 35.8707 189.572 36.9051 187.429 38.0762L186.978 38.3125C184.462 39.5728 180.89 40.4712 176.558 41.1182C172.241 41.7627 167.246 42.1468 161.93 42.418C152.011 42.9238 140.9 43.0341 131.26 43.7275L129.352 43.874C115.017 45.0528 101.616 46.3573 86.9863 46.6602L84.0439 46.707C79.0881 46.7621 73.8813 46.9425 68.6543 47.1172C63.4226 47.2921 58.1685 47.4609 53.0957 47.4941C43.2408 47.5587 34.1757 47.1083 27.373 45.2412L26.7217 45.0557C23.284 44.0435 21.6646 42.9039 20.9355 41.8438C20.2438 40.8378 20.2266 39.7118 20.5557 38.3066C20.7215 37.5986 20.962 36.8721 21.2197 36.084C21.4716 35.3136 21.739 34.4868 21.918 33.6543C22.2573 32.0756 22.3071 30.3492 21.3115 28.6914L21.0986 28.3604C20.4738 27.456 19.5393 26.6103 18.4707 25.8174C17.3935 25.018 16.1264 24.2341 14.7881 23.4688C13.4485 22.7027 12.0158 21.9428 10.6084 21.1963C9.19512 20.4467 7.8076 19.7108 6.53223 18.9814C5.2551 18.251 4.11473 17.5412 3.19531 16.8486C2.26341 16.1467 1.62565 15.5116 1.2832 14.9512C0.961341 14.4243 0.944175 14.048 1.08398 13.71C1.23164 13.3531 1.62036 12.8764 2.48926 12.3232L2.8916 12.082C5.19673 10.7726 8.70786 9.84005 13.1045 9.17578C17.4774 8.51512 22.6226 8.13347 28.1279 7.87012C38.4016 7.37867 49.9837 7.29997 59.8398 6.55273L61.7871 6.39453C77.2082 5.04498 91.2626 2.4978 106.916 2.88184L108.436 2.92871C116.844 3.23678 126.534 2.35497 135.498 1.84375Z"
                fill="none"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="endUI__secondWrapper" ref={secondWrapperRef}>
        <img
          src={images.endDoorBackground}
          alt="Arrière Plan : portes des rêves"
        />
      </div>
      <div
        className="endUI__singleDoor"
        ref={singleDoorRef}
        onPointerEnter={() => handleHover()}
        onPointerLeave={() => handleLeave()}
        // onPointerDown={() => handleClick()}
      >
        <img src={images.singleDoor} alt="Porte des rêves" />
      </div>
      <div className="endUI" ref={uiRef}>
        <div className="endUI__container" ref={containerRef}>
          <div className="endUI__wrapper">
            <img
              src={images.endPhoto}
              alt="Logo"
              className="endUI__photo"
              ref={photoRef}
            />
            <div className="endUI__wrapper__content" ref={contentRef}>
              <h1>Merci pour le Rêve de Lilian</h1>
              <p>
                Cette expérience retrace un rêve réalisé en 2017. Les noms sont
                anonymisés, mais les souvenirs sont bien réels.
                <br />
                <br />
                Grâce à vos dons et à votre soutien, nous pouvons continuer à
                transformer les rêves des enfants malades en réalité.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
